'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _resizeShopifyImageUrl2 = require('../helpers/resize-shopify-image-url');

var _resizeShopifyImageUrl3 = _interopRequireDefault(_resizeShopifyImageUrl2);

var _themeCurrency = require('@shopify/theme-currency');

var currency = _interopRequireWildcard(_themeCurrency);

var _vuejsDatepicker = require('vuejs-datepicker');

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _vueSelect = require('vue-select');

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _dateFns = require('date-fns');

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _ScrollToPlugin = require('gsap/ScrollToPlugin');

var _vuex = require('vuex');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Register GSAP Plugins
_gsap2.default.registerPlugin(_ScrollToPlugin.ScrollToPlugin);

/*----------------------------
Add To Cart Anya Subscription - Vue Component
----------------------------*/

_vue2.default.component('add-to-cart-subscription', {
  props: {
    product: Object,
    subscriptionProduct: Object,
    options: Array,
    variants: Array,
    allProducts: Array,
    allProductsMetafields: Object,
    breastfeedingMonth1: Array,
    nonBreastfeedingMonth1: Array,
    initialStatusOption: String
  },
  data: function data() {
    return {
      productHandle: window.location.pathname.split('/').pop(),
      selectedOptions: {},
      addToCartStatus: 'idle',
      shippingIntervals: [],
      selectedShippingInterval: '',
      feedbackMessage: '',
      quantity: 1,
      productHasVariants: true,
      userStatus: '',
      userDueDate: null,
      userShipmentDate: null,
      userIsBreastfeeding: false,
      userHasCsection: false,
      wasGifted: false,
      productSelections: [],
      stepOneIsActive: true,
      stepTwoIsActive: false,
      modalProducts: [],
      fixedProductSku: 'ANYA-2313455',
      disabledDates: {
        to: new Date()
      }
    };
  },

  mounted: function mounted() {
    this.setInitialOptions();
    this.setInitialSubscriptionData();
    this.setInitialModalProducts();
    this.setInitialFormValues();
  },
  components: {
    Datepicker: _vuejsDatepicker2.default,
    vSelect: _vueSelect2.default
  },
  methods: {
    /*---------------
    Set initial form values
    ---------------*/
    setInitialFormValues: function setInitialFormValues() {
      this.userStatus = this.initialStatusOption;
    },


    /*---------------
    Set initial options
    ---------------*/
    setInitialOptions: function setInitialOptions() {
      var _this = this;

      this.options.forEach(function (option) {
        _vue2.default.set(_this.selectedOptions, option.name, option.values[0]);
      });
    },


    /*---------------
    Set Initial Subscription Data
    ---------------*/
    setInitialSubscriptionData: function setInitialSubscriptionData() {
      // Shipping Intervals
      var shippingIntervalFrequencies = this.subscriptionProduct.shipping_interval_frequency.split(',');
      this.shippingIntervals = shippingIntervalFrequencies;
      this.selectedShippingInterval = shippingIntervalFrequencies[0];
    },


    /*---------------
    Set initial modal products
    ---------------*/
    setInitialModalProducts: function setInitialModalProducts() {
      var _this2 = this;

      var allProducts = [].concat((0, _toConsumableArray3.default)(this.allProducts));
      allProducts.forEach(function (product) {
        product.quantity = 1;
        product.metafields = _this2.allProductsMetafields[product.id].metafields;
      });
      this.modalProducts = this.allProducts;
    },


    /*---------------
    Due Date Selected
    ---------------*/
    onSelectDueDate: function onSelectDueDate(value) {
      // Set the due date.
      this.userDueDate = value;

      // Auto set the shipment date based on due date.
      this.userShipmentDate = (0, _dateFns.add)(value, {
        days: 14
      });
    },


    /*---------------
    Shipment Date Selected
    ---------------*/
    onSelectShipmentDate: function onSelectShipmentDate(value) {
      this.userShipmentDate = value;
    },


    /*---------------
    Date Formatter
    ---------------*/
    dateFormatter: function dateFormatter(date) {
      return (0, _dateFns.format)(date, 'MMM dd, yyyy');
    },


    /*---------------
    Set User Status
    ---------------*/
    setUserStatus: function setUserStatus(value) {
      this.userStatus = value;
      // Resize the window because the plan preview slider may switch out and we need flickity to reposition.
      window.dispatchEvent(new Event('resize'));
    },


    /*---------------
    Submit Survey
    ---------------*/
    submitSurvey: function submitSurvey() {
      var _this3 = this;

      // Open step #2
      this.stepTwoIsActive = true;
      // Resize the window because the plan preview slider may switch out and we need flickity to reposition.
      window.dispatchEvent(new Event('resize'));

      window.setTimeout(function () {
        // Scroll to the second step.
        _gsap2.default.to(window, {
          duration: 1,
          scrollTo: {
            y: '#as-product-step-2',
            offsetY: 80
          }
        });
      }, 300);

      // Set the initial product selections based on the users breastfeeding input.
      if (this.userIsBreastfeeding) {
        this.productSelections = [].concat((0, _toConsumableArray3.default)(this.breastfeedingMonth1));
      } else {
        this.productSelections = [].concat((0, _toConsumableArray3.default)(this.nonBreastfeedingMonth1));
      }

      // Set the quantity of each to 1.
      this.productSelections.forEach(function (product) {
        product.quantity = 1;
        product.metafields = _this3.allProductsMetafields[product.id].metafields;
      });
    },


    /*---------------
    Open Edit Box Modal
    ---------------*/
    openEditBoxModal: function openEditBoxModal() {
      var _this4 = this;

      // Set the quantities of the modal products based on the current product selections.
      this.modalProducts.forEach(function (product) {
        var currentProductSelection = _this4.productSelections.find(function (mProduct) {
          return mProduct.id === product.id;
        });

        if (currentProductSelection) {
          product.quantity = currentProductSelection.quantity;
        } else {
          product.quantity = 0;
        }
      });

      // Show the edit products modal.
      window.MicroModal.show('edit-products-modal', {
        awaitCloseAnimation: true
      });
    },


    /*---------------
    Save Edit Products Modal
    ---------------*/
    saveEditProductsModal: function saveEditProductsModal() {
      // Save the product selections.
      this.productSelections = JSON.parse(JSON.stringify(this.modalSelectedProducts));

      // Close the modal.
      window.MicroModal.close('edit-products-modal');
    },


    /*---------------
    Close Edit Products Modal
    ---------------*/
    closeEditProductsModal: function closeEditProductsModal() {
      window.MicroModal.close('edit-products-modal');
    },


    /*---------------
    Open Description Modal
    ---------------*/
    openDescriptionModal: function openDescriptionModal(productHandle) {
      // Show the edit products modal.
      window.MicroModal.show(productHandle + '-description-modal', {
        awaitCloseAnimation: true
      });
    },


    /*---------------
    Set option value
    ---------------*/
    setOptionValue: function setOptionValue(optionName, value) {
      // Set the option
      _vue2.default.set(this.selectedOptions, optionName, value);
      // Update the url to reflect the current variant selection.
      this.updateProductURL();
    },


    /*---------------
    Update Product URL
    ---------------*/
    updateProductURL: function updateProductURL() {
      // Save the updated product url with the variant id appended as a query string.
      var updatedURL = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + this.selectedVariant.id;
      // Replace the url without refreshing the page.
      window.history.replaceState({ path: updatedURL }, '', updatedURL);
    },


    /*---------------
    Resize Shopify Image URL
    ---------------*/
    resizeShopifyImageUrl: function resizeShopifyImageUrl(url, size) {
      return (0, _resizeShopifyImageUrl3.default)(url, size);
    },


    /*--------------- 
    Increment Quantity
    ---------------*/
    incrementQuantity: function incrementQuantity(productIndex) {
      if (this.modalSelectedProductsCount < 3) {
        var currentQuantity = this.modalProducts[productIndex].quantity;
        this.modalProducts[productIndex].quantity = currentQuantity + 1;
      }
    },


    /*---------------
    Decrement Quantity
    ---------------*/
    decrementQuantity: function decrementQuantity(productIndex) {
      var currentQuantity = this.modalProducts[productIndex].quantity;
      if (currentQuantity > 0) {
        this.modalProducts[productIndex].quantity = currentQuantity - 1;
      }
    },


    /*---------------
    Add Product To Cart
    ---------------*/
    addProductToCart: function addProductToCart() {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Indicate that the product is being added.
                _this5.addToCartStatus = 'loading';

                // Check if there is a subscription product in cart.

                if (!_this5.cartSubscriptionItem) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this5.$store.dispatch('cart/removeCartItem', _this5.cartSubscriptionItem.key);

              case 4:

                // Send the product to the cart
                _this5.$store.dispatch('cart/addCartItems', [_this5.productCartItem]).then(function () {
                  // On success indicate it and show the mini cart.
                  _this5.$store.dispatch('cart/toggleMiniCart');
                  _this5.addToCartStatus = 'done';
                  window.setTimeout(function () {
                    _this5.addToCartStatus = 'idle';
                  }, 2000);
                }).catch(function (error) {
                  // On error show the error message on the page
                  _this5.feedbackMessage = error;
                  _this5.addToCartStatus = 'idle';
                  window.setTimeout(function () {
                    _this5.feedbackMessage = '';
                  }, 3000);
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    }
  },
  computed: Object.assign({}, (0, _vuex.mapGetters)('cart', ['cartSubscriptionItem']), {

    /*---------------
    Selected Products
    ---------------*/
    modalSelectedProducts: function modalSelectedProducts() {
      return this.modalProducts.filter(function (product) {
        return product.quantity > 0;
      });
    },


    /*---------------
    Selected Products Count
    ---------------*/
    modalSelectedProductsCount: function modalSelectedProductsCount() {
      var totalModalSelectedProductsQuantity = this.modalSelectedProducts.reduce(function (accumulator, currentValue) {
        return accumulator + currentValue.quantity;
      }, 0);
      return totalModalSelectedProductsQuantity;
    },


    /*---------------
    Survey Is Complete
    ---------------*/
    surveyIsComplete: function surveyIsComplete() {
      var surveyIsComplete = this.userStatus && this.userDueDate && this.userShipmentDate ? true : false;
      return surveyIsComplete;
    },


    /*---------------
    Selected Variant
    ---------------*/
    selectedVariant: function selectedVariant() {
      var _this6 = this;

      // Get the variant that matches our currently selected options.
      return this.variants.find(function (variant) {
        return (0, _isEqual2.default)(variant.options, Object.values(_this6.selectedOptions));
      });
    },


    /*---------------
    Product Cart Item
    ---------------*/
    productCartItem: function productCartItem() {
      // Save the product selection skus into a format we can use to pass to the line item properties.
      var productSelectionSkus = {};
      this.productSelections.forEach(function (product, index) {
        productSelectionSkus['_sku_' + (index + 1)] = product.variants[0].sku + ' | ' + product.quantity;
      });

      // Save the product titles so we can attach them to the line properties.
      var productTitles = this.productSelections.map(function (product) {
        return product.title + ' ' + product.quantity + 'x';
      }).join(' | ');

      // User Data
      var dueDate = null;
      if (this.userDueDate) {
        dueDate = (0, _dateFns.formatISO)(this.userDueDate, {
          representation: 'date'
        });
      }

      var shipmentDate = null;
      if (this.userShipmentDate) {
        shipmentDate = (0, _dateFns.formatISO)(this.userShipmentDate, {
          representation: 'date'
        });
      }

      // Create the cart item data object we'll use to add to cart.
      var cartItemData = {
        id: this.subscriptionProduct.original_to_hidden_variant_map[this.selectedVariant.id].discount_variant_id,
        quantity: 1,
        properties: Object.assign({}, productSelectionSkus, {
          products: productTitles,
          // User Data - Save the due date and shipment date in ISO 8601 format because that's what we need to pass to the ReCharge api.
          _user_status: this.userStatus,
          _user_due_date: dueDate,
          _user_shipment_date: shipmentDate,
          _user_is_breastfeeding: this.userIsBreastfeeding,
          _user_has_csection: this.userHasCsection,
          _current_box: 1,
          // Subscription Info
          _subscription_original_product: this.product.handle,
          shipping_interval_frequency: this.selectedShippingInterval,
          shipping_interval_unit_type: this.subscriptionProduct.shipping_interval_unit_type,
          subscription_id: this.subscriptionProduct.subscription_id
        })
      };

      return cartItemData;
    }
  })
});